module.exports = __webpack_public_path__ + "static/media/image-video-3.1cd7f7cb.png";